import { DeletePartnerContactResponseSchema } from './delete-partner-contact.schema';
export const deletePartnerContactContract = {
    method: 'DELETE',
    path: '/api/v2/partner/contacts/:id',
    description: "Remove a contact from the caller's partner call list",
    responseSchema: DeletePartnerContactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member',
            404: "Contact not found on the caller's list"
        }
    }
};

//# sourceMappingURL=delete-partner-contact.contract.js.map